import { render, staticRenderFns } from "./WidgetAdmin.vue?vue&type=template&id=d4328ccc&scoped=true"
import script from "./WidgetAdmin.vue?vue&type=script&lang=js"
export * from "./WidgetAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4328ccc",
  null
  
)

export default component.exports